import gql from 'graphql-tag';
import { footballStatFragment, rugbyLeagueStatFragment, rugbyUnionStatFragment } from '../../../gql/fragments';
export const summaryFragment = gql `
  fragment Summary on MatchSummary {
    matchId
    clock {
      clockRunning
      clockInMs
      clockChangeDate
    }
    currentPeriod
    periods {
      duration
      name
      shortName
      code
      status
      type
      pregame
      aboutToStart
      playersEntered
      preOvertimeBreak
      shootout
      finished
      number
      started
      matchFinished
    }
    matchStats {
      home {
        ... on FootballStats {
          ...FootballStats
        }
        ... on RugbyLeagueStats {
          ...LeagueStats
        }
        ... on RugbyUnionStats {
          ...UnionStats
        }
      }
      away {
        ... on FootballStats {
          ...FootballStats
        }
        ... on RugbyLeagueStats {
          ...LeagueStats
        }
        ... on RugbyUnionStats {
          ...UnionStats
        }
      }
      players {
        playerId
        stats {
          ... on FootballStats {
            ...FootballStats
          }
          ... on RugbyLeagueStats {
            ...LeagueStats
          }
          ... on RugbyUnionStats {
            ...UnionStats
          }
        }
      }
      periods {
        period
        home {
          ... on FootballStats {
            ...FootballStats
          }
          ... on RugbyLeagueStats {
            ...LeagueStats
          }
          ... on RugbyUnionStats {
            ...UnionStats
          }
        }
        away {
          ... on FootballStats {
            ...FootballStats
          }
          ... on RugbyLeagueStats {
            ...LeagueStats
          }
          ... on RugbyUnionStats {
            ...UnionStats
          }
        }
        players {
          playerId
          stats {
            ... on FootballStats {
              ...FootballStats
            }
            ... on RugbyLeagueStats {
              ...LeagueStats
            }
            ... on RugbyUnionStats {
              ...UnionStats
            }
          }
        }
      }
      shootoutResults {
        home
        away
      }
      score {
        home
        away
      }
    }
  }
  ${footballStatFragment}
  ${rugbyUnionStatFragment}
  ${rugbyLeagueStatFragment}
`;
//# sourceMappingURL=summary.js.map